module.exports = __webpack_public_path__ + "static/img/mht.0ac9099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/mht.jpg
// module id = 7nGD
// module chunks = 21